import { Box } from '@mui/material';
import { Flag as FlagIcon } from '@mui/icons-material';
import { TextSpan } from '../../../Atoms/Text';
import { TextButton } from '../../../Atoms/TextButton';
import { AdviseFeatureResponse } from '../../../../types/advise';
import { FeatureStateLabel } from './FeatureStateLabel';

export type FlagResponse = (response: AdviseFeatureResponse, flagged: boolean) => void;

interface ResponseCellProps {
  response?: AdviseFeatureResponse;
  onFlag?: FlagResponse;
}

export const ResponseCell = ({ response, onFlag }: ResponseCellProps) => (
  <Box className="flex flex-col gap-0.5">
    <FeatureStateLabel state={response?.state ?? null} />
    {response?.note && (
      <TextSpan
        size="xs"
        color="grey6">
        Vendor note: &ldquo;{response.note}&rdquo;
      </TextSpan>
    )}
    {response?.flagged && (
      <Box className="flex flex-wrap items-center gap-x-2">
        <TextSpan
          size="xs"
          color="orange">
          <FlagIcon
            sx={{ fontSize: 14, verticalAlign: 'text-bottom' }}
            aria-hidden="true"
          />{' '}
          Flagged — verifying before scoring
        </TextSpan>
        {onFlag && (
          <TextButton
            size="xs"
            onClick={() => onFlag(response, false)}>
            Mark reviewed
          </TextButton>
        )}
      </Box>
    )}
    {response?.flagged === false && onFlag && (
      <TextButton
        size="xs"
        className="self-start"
        onClick={() => onFlag(response, true)}>
        Flag
      </TextButton>
    )}
  </Box>
);
